import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { SearchBar } from 'edcom-ui';
import styles from './Tabs.module.less';
import clsx from 'clsx';
import { replaceParams } from '../../services/content';
import { useRouter } from 'next/router';
import AppLink, { pushAppRoute } from '../../components/links/AppLink';
import Dropdown from './Dropdown';
import BrainzyAccess from './BrainzyAccess';
import AccountContext from '../../services/AccountContext';

export default function Tabs({ open, page }) {
  const router = useRouter();
  const { email, ready } = useContext(AccountContext);
  const isMember = email != null;
  const handleSearch = async (term, contentType, grade) => {
    const urlPath = `/${contentType}/${grade}/`;
    const newUrl = replaceParams(urlPath, { q: term });
    await pushAppRoute(router, newUrl);
  };

  return (
    <div className={clsx(styles.tabs, open && styles.expanded)}>
      {page !== 'search' && (
        <div className={clsx(styles.tab, styles.searchBar)}>
          <SearchBar
            placeholder="Search our library"
            cid="11.75"
            onSubmit={handleSearch}
            showDropdown={true}
          />
        </div>
      )}

      <div className={styles.tabsLinks}>
        <div className={styles.tabLink}>
          <AppLink href="/resources/" className={styles.tabText}>
            Learning Library
          </AppLink>
        </div>
        <div className={clsx(styles.tabLink, styles.mobileOnly)}>
          {ready && isMember && <BrainzyAccess isMobile={true} />}
        </div>
        <Dropdown open={open} page={page} mobileOnly={true} />
        <div className={clsx(styles.tabLink, styles.mobileOnly)}>
          <AppLink href="/summer-boost/" className={styles.tabText}>
            Summer Boost
          </AppLink>
        </div>
      </div>
    </div>
  );
}

Tabs.propTypes = {
  page: PropTypes.string,
  open: PropTypes.bool,
};

Tabs.defaultProps = {
  page: '',
};
